export default "__VITE_ASSET__YIZqdzaNCc34R5f11T8Rpw__"